import { Component, h } from 'preact'
import { Item, ItemsList } from './interfaces'
import Icon from '../assets'

interface Props {
  items: ItemsList
  onChange: (items: ItemsList) => void
  searchPlaceholderText?: string
  searchIconWidth?: number
  searchIconHeight?: number
}

interface State {
  value: string
}

function isChangeEvent (event: Event): event is ChangeEvent {
  return !!event.target && 'value' in event.target
}

class DropdownSearchbox extends Component<Props, State> {
  searchboxRef: HTMLElement | undefined

  constructor () {
    super()
    this.setState({ value: '' })

    this.onClear = this.onClear.bind(this)
  }

  componentDidMount () {
    this.makeFocused()
  }

  makeFocused () {
    this.searchboxRef?.focus()
  }

  onInput (event: ChangeEvent): void {
    const input = event.target.value

    this.setState({ value: input })

    this.props.onChange(
      this.props.items.filter((item: Item) => {
        return item.title.toLowerCase().includes(input.toLowerCase())
      })
    )
  }

  onClear () {
    this.setState({ value: '' })
    this.props.onChange(this.props.items)
  }

  render (props: Props, state: State) {
    const searchPlaceholder = props.searchPlaceholderText ?? 'Search'
    const searchIconWidth = props.searchIconWidth ?? 24
    const searchIconHeight = props.searchIconHeight ?? 24
    return (
      <div class='dropdown-searchbox'>
        <Icon icon='search' width={searchIconWidth} height={searchIconHeight} />
        <input
          className='qa-dropdown-search-box'
          id='searchbox'
          type='text'
          placeholder={searchPlaceholder}
          value={state.value}
          onInput={(e) => {
            if (isChangeEvent(e)) {
              this.onInput(e)
            }
          }}
          ref={(searchbox) => { this.searchboxRef = searchbox }}
        />
        {state.value && <Icon
          customClass='btn-clear-searchbox'
          icon='close'
          onClick={(e: ClickEvent) => {
            e.stopPropagation()
            this.onClear()
          }}
                        />}
      </div>
    )
  }
}

export default DropdownSearchbox
